import * as React from 'react';
function SvgCustomAlertDiamond(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentcolor"
      className="custom-alert-diamond_svg__fil-icon"
      {...props}
    >
      <path d="M1.28 13.281a1.812 1.812 0 010-2.561l9.44-9.439a1.808 1.808 0 012.56 0l9.44 9.439a1.812 1.812 0 010 2.561l-9.44 9.439a1.811 1.811 0 01-2.56 0l-9.44-9.439z" />
      <g className="custom-alert-diamond_svg__icon__properties">
        <path d="M12 6.75v6" />
        <circle cx={12} cy={16.5} r={0.5} />
      </g>
    </svg>
  );
}
export default SvgCustomAlertDiamond;
